import React from 'react';

export default class Schedule extends React.Component {
  constructor(){
    super();
  }
  render(){
    return (
      <div className="container">
        <div className="page profile">
          <div className="card card-lg">
            <div className="card-header">
              <h1>My Schedule</h1>
            </div>
            <div className="card-body">
              <h2>Schedule Telemedicine Visits and Surveys</h2>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

